import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { init as initFullStory } from '@fullstory/browser';
import posthog from 'posthog-js';
import { App } from './app';
import './index.css';
import '@utils/i18n';
import { ErrorBoundary } from '@components/errorBoundary';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';

if ('serviceWorker' in navigator) {
  void navigator.serviceWorker.register(
    import.meta.env.MODE === 'production' ? '/serviceWorker.js' : '/dev-sw.js?dev-sw',
  );
}

function fullStoryInit() {
  if (import.meta.env.MODE !== 'production') return;
  if (!import.meta.env.VITE_FULL_STORY_API_KEY) return;

  initFullStory({ orgId: import.meta.env.VITE_FULL_STORY_API_KEY as string });
}

function sentryInit() {
  if (!import.meta.env.VITE_SENTRY_DSN) return;

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN as string,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    environment: import.meta.env.MODE,
  });
}
function posthogInit() {
  if (!import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN) return;

  posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN as string, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST as string,
    defaults: '2026-01-30',
  });
}
sentryInit();
fullStoryInit();
posthogInit();

window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
